import { render, staticRenderFns } from "./GPageHeader.vue?vue&type=template&id=7f7791b8&scoped=true&"
import script from "./GPageHeader.vue?vue&type=script&lang=ts&"
export * from "./GPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GPageHeader.vue?vue&type=style&index=0&id=7f7791b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7791b8",
  null
  
)

export default component.exports